/* (ignored) */


//////////////////
// WEBPACK FOOTER
// buffer (ignored)
// module id = 3
// module chunks = 1